export interface IFollowUpSurveyCounts {
    centerId: number,
    allToDo: number,
    allPending: number,
    pendingSurvey: number,
    pendingReview: number,
    pendingAppointment: number,
    pendingLabOrder: number,
    pendingLabResults: number,
    completeNoResults: number,
    pendingNotifyDonor: number,
    complete: number,
    incomplete: number,
    all: number
}